import { updateWishlistBtns } from '@components/wishlist';
import { execOnLoad } from '@general/helpers';
import { initPagination } from '@services/pagination';
import './collection-page.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initCollectionPage = (context) => {
  const sectionContainer = context.classList.contains('.shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  initPagination({
    callbacks: {
      afterFetch: ({ components: { contentWrapperEl } }) => {
        if (typeof window?.dAgency?.initProductTile === 'function')
          contentWrapperEl
            .querySelectorAll('.product-tile__container')
            .forEach((tile) => window.dAgency.initProductTile(tile));
        updateWishlistBtns();
      },
    },
  });

  const productsContent = sectionContainer.querySelector(
    '.collection-page__content',
  );
  if (productsContent)
    sectionContainer
      .querySelectorAll(
        '.collection-page__view-switch-value[data-columns][data-device]',
      )
      .forEach((viewChange) =>
        viewChange.addEventListener('click', (e) => {
          e.preventDefault();
          productsContent.setAttribute(
            `data-columns-${viewChange.dataset.device}`,
            viewChange.dataset.columns,
          );
          sectionContainer
            .querySelectorAll(
              `.collection-page__view-switch-value[data-columns][data-device="${viewChange.dataset.device}"]`,
            )
            .forEach(
              (selectedView) =>
                (selectedView.dataset.active =
                  selectedView.dataset.columns == viewChange.dataset.columns &&
                  selectedView.dataset.device == viewChange.dataset.device),
            );
        }),
      );
};

execOnLoad(window.dAgency.initCollectionPage, '.collection-page__section');
